import styled from "styled-components";
import {BackOuterField, BackTableField} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React, {useState} from "react";
import {headerTypesIcons, schemas} from "../../../config";
import {Field, FIELD_TYPE_INFO, SqlOperationInfo} from "../../../Types";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {faCheck, faEdit, faQuestion, faTriangleExclamation, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SqlQuery} from "./BackTableFieldViewTable";
import EditField from "./edit/EditField";
import EditOuterField from "./edit/EditOuterField";

interface BackTableFieldPropsI {
    tableName: string,
    tableKey: string,
    field: BackOuterField,
    index: number,
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FieldItemViewPropsI = {
    field: BackOuterField,
    tableKey: string,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
    fieldSchema?: Field,
};

export default function BackTableOuterViewTable({tableName, fields}: {
    tableName: string,
    fields: Record<string, BackOuterField>,
}) {

    return <Container>
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Ключ</th>
                <th>SQL</th>
                <th>Залежать</th>
                <th>Фронт тип</th>
                <th>На фронті</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(fields).map(([key, field], i) =>
                <BackTableOuterView key={key} index={i} tableName={tableName} tableKey={key} field={field}
                />)}
            </tbody>
        </table>

    </Container>
}

function BackTableOuterView({
                                tableName,
                                tableKey,
                                field,
                                index,
                            }: BackTableFieldPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticField = staticTable !== null && staticTable.outerFields[tableKey]
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealField = etherealTable !== null && etherealTable.outerFields[tableKey]
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const project = useAppSelector(state => state.project.name);

    const fields: Field[] | undefined = schemas[project].tables[tableName]?.fields;
    const dispatch = useAppDispatch();

    let fieldSchema = fields && fields.find((v) => v.key === tableKey)

    return <>
        {mode === "edit" && staticField &&
            <OuterItemView fieldSchema={fieldSchema} type={"static"} field={staticField}
                           tableKey={tableKey}
                           index={index}/>}
        {mode === "edit" && etherealField &&
            <OuterItemView fieldSchema={fieldSchema} type={"ethereal"} editable
                           field={etherealField}
                           tableKey={tableKey} index={index}/>}
        {mode === "view" &&
            <OuterItemView fieldSchema={fieldSchema} type={"other"} field={field}
                           tableKey={tableKey} index={index}/>}
    </>
}

function OuterItemView({
                           field,
                           index,
                           tableKey,
                           type,
                           editable = false,
                           fieldSchema,
                       }: FieldItemViewPropsI) {

    const [isEditing, setIsEditing] = useState(false)
    const closeEditing = () => setIsEditing(false);

    return <>
        <tr className={"title"}>
            <td className="icon">
                {fieldSchema && <FontAwesomeTypeIcon className={'fa-color-text'} type={fieldSchema.type}/>}
                {!fieldSchema && <FontAwesomeIcon className={'fa-color-text'} icon={faQuestion}/>}
            </td>
            <td className={'key'}>
                <div className="cont">
                    <span>{tableKey}</span>
                    {editable && <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
                    </button>}
                </div>
                {isEditing &&
                    <EditOuterField closeEditing={closeEditing} field={field} fieldKey={tableKey}/>}
            </td>
            <td className="sql content">
                <div className="sql-cont">
                    <SqlQuery sqlQuery={field.sql}/>
                </div>
            </td>
            <td className="depends">
                <div className="dep">
                    {field.depends.map((d, i) => <span key={i} className="d">
                        {d}
                    </span>)}
                </div>
            </td>
            <td className="type">
                {fieldSchema && <span style={{
                    background: FIELD_TYPE_INFO[fieldSchema.type].color,
                    color: getReadableTextColor(FIELD_TYPE_INFO[fieldSchema.type].color)
                }} className={"front-type"}>{headerTypesIcons[fieldSchema.type].alt}</span>}
            </td>
            <td className="present">
                <FontAwesomeIcon size={"lg"}
                                 className={fieldSchema ? 'fa-color' : 'fa-yellow'}
                                 icon={fieldSchema ? faCheck : faXmark}/>
            </td>
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
    </>
}


const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;


    table {
        table-layout: auto;
        //max-width: 100%;
        width: 100%;
        //overflow-x: auto;
        border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border-bottom: 2px solid var(--table-border-color);
            border-right: 2px solid var(--table-border-color);
            border-left: 2px solid var(--table-border-color);
            border-top: 2px solid var(--table-border-color);

        }


        //tr:not(last-child) {
        //    td {
        //        border-bottom: 2px solid red;
        //
        //    }
        //}

        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {

        max-width: 100%;
        //overflow-x: scroll;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

        td {

            //overflow-x: auto;

        }


    }

    .present {
        text-align: center;
    }

    .depends {
        white-space: nowrap;
        width: 1%;

        .dep {
            display: inline-flex;
            gap: .5rem;

            .d {
                padding: .1rem;
                border-radius: .1rem;
                background-color: black;
                color: white;
            }
        }
    }

    .content {
        width: 100%;
    }

    .type {
        width: 1%;
    }

    .title {

        line-height: 1;

        .icon {
            //width: 1.25rem;
            //display: flex;
            //align-items: center;
            //justify-content: center;
          min-width: 1.75rem;
            width: 1%;
            text-align: center;
        }

      .key {
        width: 1%;
        text-align: left;
        padding-right: .4rem;
        padding-left: .4rem;

        .cont {
          display: inline-flex;
          gap: .5rem;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          & button {
            padding: .2rem;
          }
        }
      }

        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

        .missing {
            //background-color: #62615c;
            //color: yellow;
            //padding: .2rem .4rem;
            //border-radius: .2rem;
        }
    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

    .row {
        overflow-x: auto;
    }

    .sql {
        //display: block;
        overflow-x: auto;
        max-width: 1px;

        white-space: nowrap;

        .sql-cont {
            max-width: 100%;
            //max-width: 500px;

            word-break: break-word;
            overflow-x: auto;
        }
    }


`;
